import { createContext } from "react";
import { IContext } from "./auto-table-column-provider.types";

export const AutoTableColumnContext = createContext<IContext | undefined>(undefined);
